<template>
  <main class="sa-content sa-profile">
    <div class="sa-card-large">
  <div class="sa-mob-header ">
    <h5 class="sa-card-tit sa-h-sm-up" >Edit Profile</h5>
    <button class="sa-btn-back sa-h-sm-up" @click="$router.go(-1)"><i class="icon-left-arrow"></i></button>
    </div>
      <div class="sa-row sa-mob-cont sa-h100">
        <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg4">
          <profile-menu @change="proMenuPage = $event" />
        </div>
        <div class="sa-colxs12 sa-col-sm12 sa-col-md8 sa-col-lg8 sa-text-center" v-if="loader">
          <div class="sa-dialog-white">
            <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
          </div>
        </div>
        <div class="sa-colxs12 sa-col-sm12 sa-col-md8 sa-col-lg8" v-else>
          <div class="sa-appt-sticky sa-profile-sticky ">
            <template v-if="eflag">
              <personal-info v-if="proMenuPage == 'Personal Information' && userData" :pInfo="userData"/>
              <medical-specialities v-if="proMenuPage == 'Medical Specialities' && userData" :pInfo="userData"/>
              <education-training v-if="proMenuPage == 'Education & Training' && userData" :pInfo="userData"/>
              <certification v-if="proMenuPage == 'Certifications' && userData" :pInfo="userData"/>
              <clinic-information v-if="proMenuPage == 'Clinic Informations' && userData" :pInfo="userData"/>
            <language-spoken v-if="proMenuPage == 'Language spoken' && userData" :pInfo="userData"/>
            </template>
            <template v-else>
              <no-data-found />
            </template>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import ProfileMenuVue from '../../components/profile/ProfileMenu.vue';
import PersonalInfoVue from '../../components/profile/PersonalInfo.vue';
import MedicalSpecialitiesVue from '../../components/profile/MedicalSpecialities.vue';
import EducationTrainingVue from '../../components/profile/EducationTraining.vue';
import CertificationVue from '../../components/profile/Certification.vue';
import ClinicInformationVue from '../../components/profile/ClinicInformation.vue';
import LanguageSpokenVue from '../../components/profile/LanguageSpoken.vue';
import { pro_url } from '../../../config/endpoints'
import NoDataFoundVue from '../../components/common/NoDataFound.vue';
export default {
  components: {
    'profile-menu': ProfileMenuVue,
    'personal-info': PersonalInfoVue,
    'medical-specialities': MedicalSpecialitiesVue,
    'education-training': EducationTrainingVue,
    'certification': CertificationVue,
    'clinic-information': ClinicInformationVue,
    'language-spoken': LanguageSpokenVue,
    'no-data-found': NoDataFoundVue
  },
  data() {
    return {
      proMenuPage: 'Personal Information',
      userData: {},
      loader: false,
      eflag: true
    };
  },
  created () {
    let _self = this
    _self.getUserData()
  },
  methods: {
    updateProfile (obj, params) {
      let _self = this
      let u = _self.userData
      _.assignIn(_self.userData, u, obj);
      _self.$store.dispatch('httpPost', {          
          uri: `${pro_url}/addProfile`,
          body: _self.userData
      }).then(response => {
          if (response && response.status === 1000) {
              _self.$store.dispatch('SET_ALERTMESSAGE', { msg: "Profile updated successfully", class: 'sa-a-success' })
          } else if (response && response.status == '2001') {
              _self.$store.dispatch('SET_ALERTMESSAGE', { 'msg': 'Session Expired. Please login again', class: 'sa-a-danger' })
              _self.$localStorage.remove("token")
              _self.$localStorage.remove("userdata")
              _self.$router.push({ path: '/' })
          } else {
              _self.$store.dispatch('SET_ALERTMESSAGE', { msg: "Something went wrong", class: 'sa-a-danger' })
          }
      }).catch(e => {
          _self.$store.dispatch('SET_ALERTMESSAGE', { msg: "Something went wrong", class: 'sa-a-danger' })
      });
    },
    getUserData() {
      let _self = this
      let wobj = {
      }
      _self.loader=true
      _self.$store.dispatch('httpGet', {          
          uri: `${pro_url}/myProfile`,
          query: wobj
      }).then(response => {
          if (response && response.status === 1000) {
            _self.userData = response.data
            _self.loader=false
            let uobj = {              
              title: _self.userData.personal.title_nm,
              fn: _self.userData.personal.fn ? _self.userData.personal.fn.en : '',
              ln: _self.userData.personal.ln ? _self.userData.personal.ln.en : '',
              name: _self.userData.personal.name,
              img: _self.userData.personal.img, 
              email: _self.userData.personal.email,
              profile_complete: _self.userData.personal.profile_complete
            }
            _self.$store.dispatch("SET_AVTAR", uobj)
          } else if (response && response.status == '2001') {
              _self.$store.dispatch('SET_ALERTMESSAGE', { 'msg': 'Session Expired. Please login again', class: 'sa-a-danger' })
              _self.loader = false;
              _self.$localStorage.remove("token")
              _self.$localStorage.remove("userdata")
              _self.$router.push({ path: '/' })
          }  else {
            // _self.$router.push({path:'/404-error'})
            _self.eflag = false;
            _self.loader = false;
          }
      }).catch(e => {
          // _self.$router.push({path:'/404-error'})
            _self.eflag = false;
          _self.loading = false;
      });
    }
  },
  watch: {
    proMenuPage: {
      immediate: true,
      handler () {
        let _self = this
        _self.getUserData()
      }
    },
  }
};
</script>
